export const clipboardIsGranted = async () => {
  const responses = await Promise.all([
    navigator.permissions.query({
      // @ts-ignore
      name: 'clipboard-write',
    }),
    navigator.permissions.query({
      // @ts-ignore
      name: 'clipboard-read',
    }),
  ]);

  return responses.every(({ state }) => state !== 'denied');
};
